module.exports = __webpack_public_path__ + "static/media/aws.a71b942e.png";